import { usePersistingActor } from '@ui-common/hooks'
import { useEffectOnce } from '@ui-common/hooks/useEffectOnce'
import { SimpleTransitionStep } from '@ui-common/steps/TransitionStep'
import { isComingBackFromSigning } from '@ui-common/utils'

import { shouldHydrateState, signStepMachine } from './signStepMachine'

export interface SignStepProps {
  onSigned: (authCode: string) => void
  onError: () => void
  onCancel: () => void
  applicationId: string
}

export const SignStep = ({ onSigned, onError, onCancel, applicationId }: SignStepProps) => {
  const machine = signStepMachine({
    onDone: (authCode) => {
      onSigned(authCode)
    },
    onCancel,
    onError,
  })
  const actor = usePersistingActor(machine, shouldHydrateState, undefined, { applicationId })

  useEffectOnce(() => {
    if (isComingBackFromSigning()) {
      actor.send({ type: 'PARSE_AUTH_CODE' })
    }
  })

  return <SimpleTransitionStep />
}
